import * as effects from 'redux-saga/effects';

import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import {
  getPoliticalGroup,
  resetData,
  getDateCloture,
} from "../Dashboard/Actions";
import { buildNationalTableColumns, buildRegionalTableColumns, getStudyTypes } from '../Elections/Actions';
import { showDrawer } from '../Layout/Actions';
import { resetPlayerData } from '../Player/Actions';
import { getProgramTypes, getProgramEditors, clearPersonsList, getMediasSource, resetSearchData, getElectionCampaign } from '../Search/Actions';
import { IAuthorizedMedia } from '../Search/Types';

import { createSchema, getAuthorizedMedias, getAuthorizedMediasSuccess, getTokenPlayer, getTokenSuccess, login, loginError, loginSuccess, logout, verifyExternalToken, verifyExternalTokenError, verifyExternalTokenSuccess } from './Actions';
import { IUserActionTypes } from './Types';
import jwt from 'jwt-decode';
import { getPoliticalRegime } from "../PoliticalRegime/Actions";

function* handleGetToken(action: ReturnType<typeof getTokenPlayer>): any {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getTokenPlayer, action.payload as any);



        if (res) {
            yield effects.put(getTokenSuccess(res.expires, res.token))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed get Token player');
        yield effects.put(loginError(err));
    }
}
function* handleGetAuthorizedMedias(action: ReturnType<typeof getAuthorizedMedias>): any {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.getAuthorizedMedias, [action.payload as any]);
        let mediasID: number[] = res.map((x: any) => {
            return x.id || x.media_id
        })
        if (mediasID.length > 0) {
            yield effects.put(getMediasSource(mediasID));
        }
        yield effects.put(getAuthorizedMediasSuccess(res))
        // Recompute dateCloture now that max_advancement_date may have increased
        const token: string = action.payload as any;
        yield effects.put(getDateCloture(token));
    } catch (err) {
        Logger.warn({ err }, 'Failed getAuthorizedMedias');
    }
}
function* handleCreateSchema(action: ReturnType<typeof createSchema>): any {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.createSchema, [action.payload as any]);
        if (res.results) {

        } else {

        }
    } catch (err) {
        Logger.warn({ err }, 'Failed create');
    }
}
function* handleLogin(action: ReturnType<typeof login>): any {
    const backend = Backend.getInstance();
    try {
        const res = yield effects.apply(backend, backend.login, (action.payload as any));
        yield effects.put(createSchema(res[0]));
        yield effects.put(loginSuccess(action.payload[0], res[0], res[1], res[2], res[3], res[4]));
    } catch (err) {
        Logger.warn({ err }, 'Failed login');
        yield effects.put(loginError(err));
    }
}
function* handleLoginSuccess(action: ReturnType<typeof loginSuccess>): any {
    const backend = Backend.getInstance();
    let medias: any[] = action.payload[3];
    let token: string = action.payload[1] as string;
    let username: any = action.payload[0];
    let dashboard = yield effects.select(state => state.dashboard);
    yield effects.put(getAuthorizedMediasSuccess(medias));
    yield effects.put(getAuthorizedMedias(token));
    yield effects.put(getProgramTypes(token));
    yield effects.put(buildNationalTableColumns());
    yield effects.put(buildRegionalTableColumns());
    yield effects.put(getElectionCampaign());
    yield effects.put(getStudyTypes());
    yield effects.put(getPoliticalRegime(token));
    yield effects.put(getPoliticalGroup(token));
    yield effects.put(getProgramEditors(token));
    yield effects.put(showDrawer());
    let mediasID: number[] = medias.map((x: IAuthorizedMedia) => {
        return x.media_id
    })
    yield effects.put(getMediasSource(mediasID))

    // Fetch dateCloture after medias have populated max_advancement_date
    dashboard = yield effects.select(state => state.dashboard);
    if (dashboard.dateCloture === null && !dashboard.loadingDateCloture) {
        yield effects.put(getDateCloture(token));
    }

    const res1 = yield effects.apply(backend, backend.getTokenPlayer, [true, true, username])
    if (res1) {
        yield effects.put(getTokenSuccess(res1.expires, res1.token))
    }
}
function* handleLogout(action: ReturnType<typeof logout>) {
    try {


        yield effects.put(resetPlayerData())
        yield effects.put(clearPersonsList())
        yield effects.put(resetData())
        yield effects.put(resetSearchData())
    } catch (err) {
        Logger.warn({ err }, 'Failed logout');
        yield effects.put(loginError(err));
    }
}

function* handleVerifyExternalToken(action: ReturnType<typeof verifyExternalToken>) {
    try {
        let tokenExternal = yield effects.select(state => state.user.tokenExternal);
        if (tokenExternal !== null) {
            let token_decoded: any = jwt(tokenExternal);
            if (token_decoded.hasOwnProperty('username') && token_decoded.hasOwnProperty('exp')) {
                const expires = token_decoded['exp'];
                const expiration_date = new Date(expires * 1000);
                if (expiration_date > new Date()) {
                    yield effects.put(verifyExternalTokenSuccess(token_decoded['username'], tokenExternal, token_decoded['exp'] * 1000, token_decoded["user_id"]));
                } else {
                    yield effects.put(verifyExternalTokenError());
                }
            } else {
                yield effects.put(verifyExternalTokenError());
            }
        } else {
            yield effects.put(verifyExternalTokenError());
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed token verification');
        yield effects.put(verifyExternalTokenError());
    }
}

function* handleVerifyExternalTokenError(action: ReturnType<typeof verifyExternalTokenError>) {
    yield effects.put(loginError());
    window.document.location.href = '/';
}

function* handleVerifyExternalTokenSuccess(action: ReturnType<typeof verifyExternalTokenSuccess>) {
    const backend = Backend.getInstance();

    const username = action.payload[0] as string;
    const token = action.payload[1] as string;
    yield effects.put(getAuthorizedMedias(token));
    yield effects.put(getProgramTypes(token));
    yield effects.put(buildNationalTableColumns());
    yield effects.put(buildRegionalTableColumns());
    yield effects.put(getElectionCampaign());
    yield effects.put(getStudyTypes());
    yield effects.put(getPoliticalRegime(token));
    yield effects.put(getPoliticalGroup(token));
    yield effects.put(getProgramEditors(token));
    yield effects.put(showDrawer());
    const res1 = yield effects.apply(backend, backend.getTokenPlayer, [true, true, username])
    if (res1) {
        yield effects.put(getTokenSuccess(res1.expires, res1.token))
    }
}

function* watchLogin() {
    yield effects.takeEvery(IUserActionTypes.LOGIN, handleLogin);
    yield effects.takeEvery(IUserActionTypes.LOGIN_SUCCESS, handleLoginSuccess);
    yield effects.takeEvery(IUserActionTypes.LOGOUT, handleLogout);
    yield effects.takeEvery(IUserActionTypes.GET_TOKEN_PLAYER, handleGetToken);
    yield effects.takeEvery(IUserActionTypes.GET_AUTHORIZED_MEDIAS, handleGetAuthorizedMedias);
    yield effects.takeEvery(IUserActionTypes.VERIFY_EXTERNAL_TOKEN, handleVerifyExternalToken);
    yield effects.takeEvery(IUserActionTypes.VERIFY_EXTERNAL_TOKEN_ERROR, handleVerifyExternalTokenError);
    yield effects.takeEvery(IUserActionTypes.VERIFY_EXTERNAL_TOKEN_SUCCESS, handleVerifyExternalTokenSuccess);
    yield effects.takeEvery(IUserActionTypes.CREATE_SCHEMA, handleCreateSchema);
}

export function* UserSaga() {
    yield effects.all([
        effects.fork(watchLogin),
    ]);
}
